import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '漫画分类',
    links: [
      { name: '浪漫爱情', href: '/category/romance' },
      { name: '奇幻冒险', href: '/category/fantasy' },
      { name: '动作热血', href: '/category/action' },
      { name: '悬疑惊悚', href: '/category/thriller' },
    ],
  },
  {
    title: '更多分类',
    links: [
      { name: '搞笑日常', href: '/category/comedy' },
      { name: '都市职场', href: '/category/urban' },
      { name: '热门推荐', href: '/' },
      { name: '最新更新', href: '/' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', href: '/about' },
      { name: '联系方式', href: '/about' },
      { name: '用户协议', href: '/about' },
      { name: '隐私政策', href: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-4">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-read-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-950">
                韩漫漫画网
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5 max-w-xs">
              韩漫漫画网是热门漫画在线阅读平台，实现全网韩漫最快更新，涵盖韩漫大全，内容多样，加载快捷，为您提供极速阅读服务。
            </p>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-colors"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-colors"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-colors"
                aria-label="QQ"
                rel="nofollow"
              >
                <i className="ri-qq-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title} className="md:col-span-2">
              <h4 className="text-xs font-label font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-2">
            <h4 className="text-xs font-label font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-sm text-foreground-400"></i>
                </div>
                <span>hello@j3zb.com</span>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-sm text-foreground-400"></i>
                </div>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line text-sm text-foreground-400"></i>
                </div>
                <span>北京市朝阳区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩漫漫画网 版权所有 | 京ICP备2024000001号
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <Link to="/about" className="hover:text-primary-500 transition-colors whitespace-nowrap">
              用户协议
            </Link>
            <Link to="/about" className="hover:text-primary-500 transition-colors whitespace-nowrap">
              隐私政策
            </Link>
            <Link to="/about" className="hover:text-primary-500 transition-colors whitespace-nowrap">
              版权声明
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}